import React, { useCallback, useLayoutEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { isMobile } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { gameStore } from '../../../store';
import { NumPadWr } from '../../mobile/numPad';
import { BetAmount } from './betAmount';
import { AutoBetEndCashOutSection } from './autoBetEndCashout';
import { animationStore } from '../../../store/animationStore';
import { NumpadWrapper } from './NumPadWr';

let mobileWrRef;
export const BettingPart = observer(({ t }) => {
  const { limits } = gameConfigStore;
  const {
    numPadData: { sectionName, isOpenNumpad },
    activeGameType,
  } = gameStore;
  const { isGameClosedByGameType } = animationStore;

  const [namPudInputValue, updateNumPudInputValue] = useState(limits.minBet);

  useLayoutEffect(() => {
    mobileWrRef = document.querySelector('.mobile-wr');
  }, []);

  const handleOpenNumPad = useCallback(
    (event, openedNumpadName) => {
      if (isMobile()) {
        updateNumPudInputValue(event.target.value);
        gameStore.setNumPadData({
          isOpenNumpad: true,
          sectionName: openedNumpadName,
          currentInputValue: event.target.value,
        });
      }
    },
    [isOpenNumpad]
  );

  return (
    <div
      className={`game-center-bottom  ${isGameClosedByGameType[activeGameType] ? 'disabled' : ''}`}
    >
      <div className='game-bet-wrp'>
        <div className='game-bet-holder'>
          <div className='game-bet-ins'>
            <div className='game-bet-btn-inside'>
              <BetAmount t={t} handleOpenNumPad={handleOpenNumPad} />
              <AutoBetEndCashOutSection t={t} handleOpenNumPad={handleOpenNumPad} />
            </div>
          </div>
        </div>
      </div>

      <NumPadWr containerRef={mobileWrRef}>
        <NumpadWrapper
          namPudInputValue={namPudInputValue}
          sectionName={sectionName}
          activeGameType={activeGameType}
          limits={limits}
          updateNumPudInputValue={updateNumPudInputValue}
          isOpenNumpad={isOpenNumpad}
          t={t}
        />
      </NumPadWr>
    </div>
  );
});
